<template>
  <!-- 快捷功能2.0 -->
  <div id="shortcut-function-bar" class="arrow_box">
    <div class="shortcut-fun-item" id="shortcut-fun-btngroup">
      <div class="shortcut-fun-item-title">本单可以进行如下操作</div>
      <div class="shortcut-fun-item-content-outer">
        <div class="shortcut-fun-item-content">
          <div class="shortcut-fun-part-title">公共</div>
          <div class="shortcut-fun-part" type="ckxq"><i class="shortcut-icon l-icon l-icon-wangluodingdan"></i>详情</div>
          <div class="shortcut-fun-part">
            <i class="shortcut-icon l-icon l-icon-photograph"></i>图片
            <div class="shortcut-fun-part-mini-outer">
              <div class="shortcut-fun-part-mini">
                <div class="shortcut-fun-child" type="bdsc">本地上传</div>
                <div class="shortcut-fun-child" type="gpysc">高拍仪上传</div>
              </div>
            </div>
          </div>
          <div class="shortcut-fun-part" type="hwgz"><i class="shortcut-icon l-icon l-icon-map"></i>跟踪</div>
          <div class="shortcut-fun-part">
            <i class="shortcut-icon l-icon l-icon-print"></i>打印
            <div class="shortcut-fun-part-mini-outer">
              <div class="shortcut-fun-part-mini">
                <div class="shortcut-fun-child" type="print_tyd">托运单</div>
                <div class="shortcut-fun-child" type="print_bq">标签</div>
                <div class="shortcut-fun-child" type="print_xf">信封</div>
                <div class="shortcut-fun-child" type="print_hkpz">回扣凭证</div>
              </div>
            </div>
          </div>
        </div>
        <div class="shortcut-fun-item-content">
          <div class="shortcut-fun-part-title">操作</div>
          <div class="shortcut-fun-part" type="blth" type-title="办理提货"><i class="shortcut-icon l-icon l-icon-yidizhuangxiefei"></i>提货</div>
          <div class="shortcut-fun-part" type="blsh"><i class="shortcut-icon l-icon l-icon-songhuo"></i>送货</div>
          <div class="shortcut-fun-part" type="qsdj"><i class="shortcut-icon l-icon l-icon-songhuoqianshou"></i>签收</div>
          <div class="shortcut-fun-part">
            <i class="shortcut-icon l-icon l-icon-bendidaili"></i>中转
            <div class="shortcut-fun-part-mini-outer">
              <div class="shortcut-fun-part-mini">
                <div class="shortcut-fun-child" type="bddl" type-title="本地代理">本地</div>
                <div class="shortcut-fun-child" type="zddl" type-title="终端代理">终端</div>
              </div>
            </div>
          </div>
        </div>
        <div class="shortcut-fun-item-content">
          <div class="shortcut-fun-part-title">运单</div>
          <div class="shortcut-fun-part">
            <i class="shortcut-icon l-icon l-icon-edit"></i>改单
            <div class="shortcut-fun-part-mini-outer">
              <div class="shortcut-fun-part-mini">
                <div class="shortcut-fun-child" type="kdgd">业务改单</div>
                <div class="shortcut-fun-child" type="cwgd">财务改单</div>
              </div>
            </div>
          </div>
          <div class="shortcut-fun-part" type="ydsh"><i class="shortcut-icon l-icon l-icon-shenhe"></i>审核</div>
          <div class="shortcut-fun-part" type="ydzf"><i class="shortcut-icon l-icon l-icon-cancel"></i>作废</div>
        </div>
        <div class="shortcut-fun-item-content">
          <div class="shortcut-fun-part-title">回单</div>
          <div class="shortcut-fun-part" type="hdqs"><i class="shortcut-icon l-icon l-icon-huidanqianshou"></i>签收</div>
          <div class="shortcut-fun-part" type="hdjc"><i class="shortcut-icon l-icon l-icon-huidanjichu"></i>寄出</div>
          <div class="shortcut-fun-part" type="hdsd"><i class="shortcut-icon l-icon l-icon-huidanshoudao"></i>收到</div>
          <div class="shortcut-fun-part" type="hdfc"><i class="shortcut-icon l-icon l-icon-huidanfanchang"></i>返厂</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { includeLinkList, includeScriptList } from '@/utils/common'
import { CSS_BASEURL, SCRIPT_BASEURL } from '@/utils/enum'

export default {
  name: 'ShortcutFunction',
  mounted () {
    includeLinkList([
      CSS_BASEURL + '/shared/shortcutFunction.css'
    ])
    includeScriptList([
      SCRIPT_BASEURL + '/shared/shortcutFunction.js'
    ])
  }
}
</script>

<style scoped>

</style>
